import React, { useState, useReducer, useContext } from "react";
import ReactHtmlParser from "react-html-parser";
import styled from "styled-components";
import { GridColumn } from "notes";
import {
  FormMessage,
  handleErrors,
  firebase,
  TimeContext,
  EventContext,
} from "Components";
import { reducer } from "Modules";
import analytics from "services/analytics";
import { fonts } from "theme/fonts";
import { FormFields } from "./FormFields";

export const RegistrationForm = ({
  formData,
  onSuccess,
  formPart,
  email,
  zip,
  ...props
}) => {
  const [registration, setRegistration] = useReducer(reducer, {});
  const [errors, setErrors] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const { time } = useContext(TimeContext);
  const { event } = useContext(EventContext);

  const {
    fields,
    formId,
    formLegal,
    ageGateMessage,
    mastercampaignId,
  } = formData;

  const handleChange = (value, name) => {
    setRegistration(value);
    delete errors[name];
    setErrors(errors);
  };

  const handleSubmit = async () => {
    let errorObject = handleErrors(fields, registration, formPart);

    if (!errorObject) {
      setSubmitting(true);
      try {
        const submitForm = firebase.functions().httpsCallable("leads-submit");
        await submitForm({
          form: {
            ...registration,
          },
          email: email ?? registration.EMAIL,
          formId: formId,
          mcId: mastercampaignId,
          eventId: event.id,
        }).then(({ data }) => {
          if (!!data.token) {
            onSuccess(
              false,
              data.token,
              formPart,
              registration.EMAIL,
              registration.ZIP
            );
            setSubmitting(false);
            analytics.fireEvent({
              category: `Form Submit Part ${formPart}`,
              action: "Success",
              label: window.location.host,
              formData: {
                ...registration,
                email: email ?? registration.EMAIL,
              },
            });
          }
        });
      } catch (error) {
        setSubmitting(false);
      }
    } else {
      setErrors(errorObject);
    }
  };

  return (
    <>
      <FormFields
        formData={formData}
        formPart={formPart}
        handleChange={handleChange}
        errors={errors}
        registration={registration}
      />

      <FormMessage
        active={!!errors?.AGE_GATE}
        content={ageGateMessage}
        style={{ order: 6 }}
      />

      <ButtonContainer>
        {submitting ? (
          <RegisterButton disabled>Loading</RegisterButton>
        ) : (
          <RegisterButton onClick={() => handleSubmit()}>
            {time < formData.endSweeps
              ? formPart === 1
                ? "Obtén Tu Ticket Gratuito"
                : "Enviar"
              : formPart === 1
              ? "Enviar"
              : "Obtén Tu Ticket Gratuito"}
          </RegisterButton>
        )}
      </ButtonContainer>

      {formLegal && <FormLegal>{ReactHtmlParser(formLegal)}</FormLegal>}
    </>
  );
};

const ButtonContainer = styled(GridColumn)`
  margin: 16px 0 0 0;
  order: 7;
`;

const RegisterButton = styled.button`
  background-color: #4580dd;
  color: #ffffff;
  font-family: ${fonts.brandLight};
  transition: all ease 0.3s;
  outline: none;
  border: none;
  padding: 25px;

  &:hover,
  &:focus {
    background-color: #305da2;
  }

  @media only screen and ${(props) => props.theme.maxMedia.small} {
    font-size: 26px;
  }
`;

const FormLegal = styled.p`
  color: #fafafa;
  font-size: 12px;
  padding: 8px 3px 0 3px;
  order: 8;

  a,
  a:hover {
    color: #fafafa;
    text-decoration: underline;
  }
`;
